import { useCms } from '../state/api';
import { Res } from '../state/api-resources';
import { UiContainer } from '../state/ui';
import { CmsComponent } from './cms/CmsComponent';
import { Loader } from './Loader/Loader';

export const GlobalMessage = (): JSX.Element => {
	const { data: globalMessage, isLoading } = useCms(Res.cmsComponent, { slug: 'global-message' });
	const ui = UiContainer.useContainer();

	if (!globalMessage?.length) return <></>;

	return (
		<div className={`${ui.isHeaderSticky ? 'sticky' : ''}`}>
			{isLoading ? <Loader /> : <CmsComponent structure={globalMessage} />}
		</div>
	);
};
